"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QualificationsJobPartnerMatch = void 0;
const qualifications_of_partners_1 = require("./qualifications-of-partners");
const qualifications_required_for_job_1 = require("./qualifications-required-for-job");
const typeorm_1 = require("typeorm/browser");
let QualificationsJobPartnerMatch = class QualificationsJobPartnerMatch {
};
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
    }),
    __metadata("design:type", String)
], QualificationsJobPartnerMatch.prototype, "jobSfid", void 0);
__decorate([
    (0, typeorm_1.Column)('varchar', {
        length: 18,
    }),
    __metadata("design:type", String)
], QualificationsJobPartnerMatch.prototype, "partnerId", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], QualificationsJobPartnerMatch.prototype, "isRemote", void 0);
__decorate([
    (0, typeorm_1.Column)('boolean'),
    __metadata("design:type", Boolean)
], QualificationsJobPartnerMatch.prototype, "match", void 0);
QualificationsJobPartnerMatch = __decorate([
    (0, typeorm_1.ViewEntity)({
        dependsOn: [qualifications_of_partners_1.QualificationsOfPartner, qualifications_required_for_job_1.QualificationsRequiredForJob],
        expression: `
  SELECT
    job_sfid,
    partner_id,
    is_remote,
    (
      (
        CARDINALITY(qrj.hwo_a || qrj.hwo_b1 || qrj.hwo_b2 || qrj.kein_hwo || qrj.zusatzqualifikation) = 0 -- no qialificatoins required
        OR (qrj.hwo_a && qp.hwo_a AND CARDINALITY(qrj.hwo_a) > 0)
        OR (qrj.hwo_b1 && qp.hwo_b1 AND CARDINALITY(qrj.hwo_b1) > 0)
        OR (qrj.hwo_b2 && qp.hwo_b2 AND CARDINALITY(qrj.hwo_b2) > 0)
        OR (qrj.kein_hwo && qp.kein_hwo AND CARDINALITY(qrj.kein_hwo) > 0)
        OR (qrj.zusatzqualifikation && qp.zusatzqualifikation AND CARDINALITY(qrj.zusatzqualifikation) > 0)
      )
      AND (qrj.weiterbildung && qp.weiterbildung OR CARDINALITY(qrj.weiterbildung) = 0)
      AND (qrj.transporter && qp.transporter OR CARDINALITY(qrj.transporter) = 0)
    ) "match"
  FROM
    public.qualifications_required_for_job qrj
  CROSS JOIN
    public.qualifications_of_partner qp
  `,
        name: 'qualifications_job_partner_match',
        schema: 'public',
    })
], QualificationsJobPartnerMatch);
exports.QualificationsJobPartnerMatch = QualificationsJobPartnerMatch;
//# sourceMappingURL=qualifications-job-partner-match.js.map